import ScrollClass from '../modules/ScrollClass';
import HamburgerMenu from '../modules/HamburgerMenu';
import SetSwiper from '../modules/SetSwiper';
import SetShareStories from '../modules/SetShareStories';
import SetShareCommon from '../modules/SetShareCommon';

console.log("special_onigiri-pj.js");

let $loading = $('.opj-parts__loading');

// init
new HamburgerMenu();
new SetSwiper();
new SetShareStories();
new SetShareCommon();

// loading
$loading.addClass('opj-is__show');

window.addEventListener("load", function (e) {
	console.log('load');
	$loading.addClass('opj-is__hide');
	// スクロールアニメーションクラス
	new ScrollClass($('.opj-target'));
});